/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Product_Not_AvailableInputs */

const en_admin_resource_form_product_not_available = /** @type {(inputs: Admin_Resource_Form_Product_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const de_admin_resource_form_product_not_available = /** @type {(inputs: Admin_Resource_Form_Product_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht verfügbar`)
};

const es_admin_resource_form_product_not_available = /** @type {(inputs: Admin_Resource_Form_Product_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const fr_admin_resource_form_product_not_available = /** @type {(inputs: Admin_Resource_Form_Product_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

/** @type {(inputs: Admin_Resource_Form_Product_Not_AvailableInputs) => LocalizedString} */
const it_admin_resource_form_product_not_available = en_admin_resource_form_product_not_available;

/** @type {(inputs: Admin_Resource_Form_Product_Not_AvailableInputs) => LocalizedString} */
const pt_br2_admin_resource_form_product_not_available = en_admin_resource_form_product_not_available;

/** @type {(inputs: Admin_Resource_Form_Product_Not_AvailableInputs) => LocalizedString} */
const pl_admin_resource_form_product_not_available = en_admin_resource_form_product_not_available;

/** @type {(inputs: Admin_Resource_Form_Product_Not_AvailableInputs) => LocalizedString} */
const hu_admin_resource_form_product_not_available = en_admin_resource_form_product_not_available;

/** @type {(inputs: Admin_Resource_Form_Product_Not_AvailableInputs) => LocalizedString} */
const ro_admin_resource_form_product_not_available = en_admin_resource_form_product_not_available;

/**
* | output |
* | --- |
* | "N/A" |
*
* @param {Admin_Resource_Form_Product_Not_AvailableInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_product_not_available = /** @type {((inputs?: Admin_Resource_Form_Product_Not_AvailableInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Product_Not_AvailableInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_product_not_available(inputs)
	if (locale === "de") return de_admin_resource_form_product_not_available(inputs)
	if (locale === "es") return es_admin_resource_form_product_not_available(inputs)
	if (locale === "fr") return fr_admin_resource_form_product_not_available(inputs)
	if (locale === "it") return it_admin_resource_form_product_not_available(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_product_not_available(inputs)
	if (locale === "pl") return pl_admin_resource_form_product_not_available(inputs)
	if (locale === "hu") return hu_admin_resource_form_product_not_available(inputs)
	return ro_admin_resource_form_product_not_available(inputs)
});
export { admin_resource_form_product_not_available as "admin.resource_form.product_not_available" }